import { render, staticRenderFns } from "./sedan.vue?vue&type=template&id=8a55708c&scoped=true"
import script from "./sedan.vue?vue&type=script&setup=true&lang=ts"
export * from "./sedan.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./sedan.vue?vue&type=style&index=0&id=8a55708c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a55708c",
  null
  
)

export default component.exports